export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";